var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDasboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.125C3 3.50368 3.50368 3 4.125 3H9.58929C10.2106 3 10.7143 3.50368 10.7143 4.125V8.30357C10.7143 8.92489 10.2106 9.42857 9.58929 9.42857H4.125C3.50368 9.42857 3 8.92489 3 8.30357V4.125ZM4.4625 7.96607V4.4625H9.25179V7.96607H4.4625Z",
    fill: "#484B53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2856 15.6964C13.2856 15.0751 13.7893 14.5714 14.4106 14.5714H19.8749C20.4963 14.5714 20.9999 15.0751 20.9999 15.6964V19.875C20.9999 20.4963 20.4963 21 19.8749 21H14.4106C13.7893 21 13.2856 20.4963 13.2856 19.875V15.6964ZM14.7481 19.5375V16.0339H19.5374V19.5375H14.7481Z",
    fill: "#484B53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 10.7143C3.50368 10.7143 3 11.218 3 11.8393V19.875C3 20.4963 3.50368 21 4.125 21H9.58929C10.2106 21 10.7143 20.4963 10.7143 19.875V11.8393C10.7143 11.218 10.2106 10.7143 9.58929 10.7143H4.125ZM4.4625 12.1768V19.5375H9.25179V12.1768H4.4625Z",
    fill: "#484B53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2856 4.125C13.2856 3.50368 13.7893 3 14.4106 3H19.8749C20.4963 3 20.9999 3.50368 20.9999 4.125V12.1607C20.9999 12.782 20.4963 13.2857 19.8749 13.2857H14.4106C13.7893 13.2857 13.2856 12.782 13.2856 12.1607V4.125ZM14.7481 11.8232V4.4625H19.5374V11.8232H14.7481Z",
    fill: "#484B53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDasboard);
export default __webpack_public_path__ + "static/media/icon-dasboard.f24c6bde4309ac3ed99f863d8164128a.svg";
export { ForwardRef as ReactComponent };